module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon6.1c69ffce.svg";